const getCurrentSpan = ({
  audioState,
  currentSpeechMark,
  readAloudSpanRefs,
  textChunks,
}) => {
  const startingCharacterIndex = currentSpeechMark?.start;
  const currentChunk = textChunks[audioState.currentTextChunkIndex];
  const identifier = currentChunk?.identifier;
  const currentBlockElement = readAloudSpanRefs?.current[identifier];
  const currentSpan = currentBlockElement?.querySelector(
    `[data-starting-character-index='${startingCharacterIndex}']`,
  );
  return currentSpan;
};

export default getCurrentSpan;
